import { createFileRoute, redirect } from '@tanstack/react-router';

// The household rotation admin now lives under Settings → Menu.
export const Route = createFileRoute('/menu')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { section: 'menu' } });
  },
});
